// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wheelbarrowing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wheelbarrowing/wheelbarrowing.js';

mount([g0]);
